import React from 'react';
import ChamadoDescriptionField from './ChamadoDescriptionField';
import ChamadoTypeField from './ChamadoTypeField';
import ChamadoSectorField from './ChamadoSectorField';
import ChamadoUserField from './ChamadoUserField';
import ChamadoEmailField from './ChamadoEmailField';
import ChamadoAttachmentField from './ChamadoAttachmentField';
import ChamadoSubmitButton from './ChamadoSubmitButton';

function ChamadoCreateForm({
    descricao,
    setDescricao,
    tipo,
    setTipo,
    setor,
    setSetor,
    codSis,
    setCodSis,
    codEqp,
    setCodEqp,
    listSistemas,
    listaEquipamento,
    tipos,
    nomeUsuario,
    emailAdicional,
    setEmailAdicional,
    nomeAnexo,
    onAnexoChange,
    onSubmit,
    salvando,
    mensagem,
    sugestaoIA,
    sugestaoIALoading,
    sugestaoIAMensagem,
    chamadosRelacionados,
    onBuscarSugestaoIA,
}) {
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(e);
    };

    return (
        <form className="chamado-create-form" onSubmit={handleSubmit}>

            <section className="chamado-create-section" aria-labelledby="section-descricao">
                <h2 id="section-descricao" className="chamado-create-section-title">Descrição</h2>
                <ChamadoDescriptionField value={descricao} onChange={setDescricao} />
            </section>

            <section className="chamado-create-section" aria-labelledby="section-classificacao">
                <h2 id="section-classificacao" className="chamado-create-section-title">Classificação</h2>
                <ChamadoTypeField value={tipo} onChange={setTipo} tipos={tipos} />
                <ChamadoSectorField
                    value={setor}
                    onChange={setSetor}
                    codSis={codSis}
                    setCodSis={setCodSis}
                    codEqp={codEqp}
                    setCodEqp={setCodEqp}
                    listSistemas={listSistemas}
                    listaEquipamento={listaEquipamento}
                />
            </section>

            <section className="chamado-create-section" aria-labelledby="section-contato">
                <h2 id="section-contato" className="chamado-create-section-title">Contato e anexo</h2>
                <ChamadoUserField value={nomeUsuario} />
                <ChamadoEmailField value={emailAdicional} onChange={setEmailAdicional} />
                <ChamadoAttachmentField nomeArquivo={nomeAnexo} onFileChange={onAnexoChange} />
            </section>

            {onBuscarSugestaoIA && (
                <div className="chamado-ia-panel field-full">
                    <div className="chamado-ia-head">
                        <div className="chamado-ia-title">
                            <span className="chamado-ia-spark"><i className="fas fa-wand-magic-sparkles" /></span>
                            <div>
                                <strong>Assistente de abertura</strong>
                                <span>Procura soluções em chamados já atendidos</span>
                            </div>
                        </div>
                        <button
                            type="button"
                            className="sol-btn sol-btn--soft"
                            onClick={onBuscarSugestaoIA}
                            disabled={sugestaoIALoading}
                            title="Busca chamados fechados parecidos e sugere verificações com base na IA"
                        >
                            {sugestaoIALoading ? <><span className="sol-spinner" /> Buscando...</> : <><i className="fas fa-magnifying-glass" /> Verificar solução</>}
                        </button>
                    </div>
                    {sugestaoIAMensagem && <p className="chamado-ia-msg">{sugestaoIAMensagem}</p>}
                    {sugestaoIA && (
                        <div className="chamado-ia-result">
                            <strong><i className="fas fa-lightbulb" /> Sugestão</strong>
                            <p>{sugestaoIA}</p>
                            {chamadosRelacionados?.length > 0 && (
                                <small>Chamados parecidos já atendidos: #{chamadosRelacionados.map((c) => c.satNum).join(', #')}</small>
                            )}
                        </div>
                    )}
                </div>
            )}

            <ChamadoSubmitButton loading={salvando} disabled={false} />

            {mensagem && (
                <div className="chamado-create-message error" role="alert">
                    <i className="fas fa-circle-exclamation" /> {mensagem}
                </div>
            )}
        </form>
    );
}

export default ChamadoCreateForm;
